export default function PageHeader({title}) {
    return (
        <div id = "page-header">
            <h1>{title}</h1>
        </div>
    )
}